module.exports = __webpack_public_path__ + "img/icon-play-circle.22ff6424.svg";